import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subscription, filter } from 'rxjs';
import * as HelpActions from 'src/app/store/help/help.actions';
import { selectSubsectionModify, selectSubsections } from 'src/app/store/help/help.selector';
import { SubSectionDataDb } from 'src/app/model/help';

@Component({
  templateUrl: './helper-order-subsection.dialog.component.html',
})

export class HelperOrderSubSectionDialogComponent implements OnInit, OnDestroy {
   subsections: SubSectionDataDb[];

   subsections$: Observable <SubSectionDataDb[] | undefined>;
   subsectionsSub: Subscription | undefined;
   subsectionModify$: Observable <boolean | undefined>;
   subsectionModifySub: Subscription | undefined;

   sectionId: number;

   // design
   screenWidth: number;
   MIN_MD_WIDTH = 500;
   MAX_MD_WIDTH = 1120;
   MIN_WIDTH_COL4 = 1680;
   DELTA_ERROR_PIXEL = 7;
   MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

   constructor(
      private store: Store < AppState > ,
      private ref: DynamicDialogRef,
      public config: DynamicDialogConfig,
   ) {
      if (config.data !== undefined && config.data.sectionId !== undefined) {
         this.sectionId = config.data.sectionId;
      }
      this.initSelectors();
   }

   // Design
   @HostListener('window:resize', ['$event'])
   onResize() {
      this.screenWidth = window.innerWidth;
   }

   ngOnInit(): void {
      if (this.sectionId) {
         this.store.dispatch(HelpActions.getHelpSubSections({
            sectionId: this.sectionId
         }));
      }
      this.subscribeAll();
   }

   initSelectors(): void {
      this.subsectionModify$ = this.store.select(selectSubsectionModify);
      this.subsections$ = this.store.select(selectSubsections);
   }

   subscribeAll(): void {
      this.subsectionsSub = this.subsections$?.subscribe((subsections) => {
         this.subsections = subsections;
      });
      this.subsectionModifySub = this.subsectionModify$?.pipe(filter(subsectionModify => !!subsectionModify))
         .subscribe(() => {
            if (this.sectionId) {
               this.store.dispatch(HelpActions.getHelpSubSections({
                  sectionId: this.sectionId
               }));
            }
         });
   }

   ngOnDestroy(): void {
      this.subsectionsSub?.unsubscribe();
      this.subsectionModifySub?.unsubscribe();
   }

   rowReorder(event) {
      this.subsections[event.dropIndex].Order = event.dropIndex;
      this.store.dispatch(HelpActions.editHelpSubSection({ subsection : this.subsections[event.dropIndex] }));
  }

   saveOrder(): void {
   }

   closeDialog(): void {
      this.ref.close();
   }

   dynamicButtonWidth(): string {
      return (this.screenWidth <= this.MIN_TWO_BUTTONS_DIALOG_WIDTH) ? "w-full" : "w-16rem";
   }
}